import { onViewLoad } from "~/jose_modern/on_view_load";
import { initBillingHistory } from "./billing";

onViewLoad("users#billing_history", () => {
  initBillingHistory();
});
